var map = {
	"./Icono (1).svg": "c1f2",
	"./Icono1-1.png": "72ce",
	"./Icono1-2.png": "1d36",
	"./Iconodg-1.png": "de62",
	"./Iconodg-2.png": "798e",
	"./Iconodg-3.png": "8c12",
	"./Iconodg-4.png": "0b74",
	"./Iconodg-5.png": "842f",
	"./Iconodg-6.png": "6948",
	"./Iconodg-7.png": "2f4e",
	"./boton Nuevamente.svg": "a118",
	"./boton comprobar.svg": "6559",
	"./img1.png": "5ee3",
	"./img2.png": "560b",
	"./img3.png": "9e5b",
	"./img4.png": "1f7b",
	"./img5.png": "4a93",
	"./img6.png": "2798",
	"./img7.png": "d7df",
	"./img8.png": "107e",
	"./pantalla 4-1 mobile.svg": "a607",
	"./pantalla 4-1.svg": "6388",
	"./pantalla 5-1.svg": "7569",
	"./pantalla 5-4.svg": "07af",
	"./pantalla 6-8.svg": "c876",
	"./pantalla 7-1 mobile.svg": "f6d1",
	"./pantalla 7-1.svg": "6fda",
	"./pantalla 7-11.svg": "5323",
	"./pantalla-1-1-slider.png": "a88b",
	"./pantalla-1-1.png": "6e23",
	"./pantalla-1-10.png": "d445",
	"./pantalla-1-13.png": "56ea",
	"./pantalla-1-2.png": "afa1",
	"./pantalla-1-3-1.png": "ae12",
	"./pantalla-1-3-2.png": "c51c",
	"./pantalla-1-3-3.png": "3655",
	"./pantalla-1-3.png": "73cf",
	"./pantalla-1-4.png": "4719",
	"./pantalla-1-8.png": "1376",
	"./pantalla-1-9.png": "1179",
	"./pantalla-2-1.png": "b280",
	"./pantalla-2-10.png": "3e66",
	"./pantalla-2-11.png": "bc92",
	"./pantalla-2-12.png": "cf5b",
	"./pantalla-2-2.png": "192a",
	"./pantalla-2-3.png": "f062",
	"./pantalla-2-4.png": "1a55",
	"./pantalla-2-5.png": "551c",
	"./pantalla-2-6.png": "b20b",
	"./pantalla-2-7.png": "188d",
	"./pantalla-2-8.png": "1d30",
	"./pantalla-2-9.png": "2eb1",
	"./pantalla-2-sliders.png": "ddf3",
	"./pantalla-3-1-10.png": "3b8c",
	"./pantalla-3-2.png": "afc9",
	"./pantalla-3-3.png": "63c3",
	"./pantalla-3-4.png": "1218",
	"./pantalla-3-5.png": "b596",
	"./pantalla-3-6.png": "51c8",
	"./pantalla-4-1-mobile.png": "7729",
	"./pantalla-4-1.png": "0407",
	"./pantalla-6-1.png": "3faa",
	"./pantalla-6-2.png": "273e",
	"./pantalla-6-3.png": "a357",
	"./pantalla-6-4.png": "0b52",
	"./pantalla-6-5.png": "bd8b",
	"./pantalla-6-6.png": "0673",
	"./pantalla-6-7.png": "caee",
	"./pantalla-6-8.png": "1fd2",
	"./pantalla-6-9.png": "0a8e",
	"./pantalla-7-1-mobile.png": "5bd9",
	"./pantalla-7-1.png": "69ed",
	"./pantalla-7-2.png": "4d7e",
	"./pantalla-7-3.png": "5c1e",
	"./pantalla-7-4.png": "c37c",
	"./pantalla-7-5.png": "d5a5",
	"./pantalla-7-6.png": "21b8",
	"./pantalla-7-7.png": "09b9",
	"./pantalla-7-8.png": "eecf",
	"./pantalla-8-mobile.png": "49dc",
	"./pantalla1-1.png": "871a",
	"./pantalla1-2.png": "eebd",
	"./pantalla1-3.png": "df1a",
	"./pantalla2-1.png": "fd2a",
	"./pantalla2-2.png": "5ddb",
	"./pantalla2-3.png": "ea8b",
	"./pantalla2-4.png": "44d8",
	"./pantalla2-5.png": "98fd",
	"./pantalla2-6.png": "e534",
	"./pantalla2-7.png": "c942",
	"./pantalla6-1.png": "59ff",
	"./pantalla6-2.png": "b79b",
	"./pantalla6-3.png": "adbd",
	"./pantalla6-4.png": "7588",
	"./pantalla7-1.png": "28fe",
	"./pregunta-4.png": "b4b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f5a";